export const isNumber = (s: string): boolean => {
  const reg = /^-?\d+\.?\d*$/
  return reg.test(s) && !isNaN(parseFloat(s)) && isFinite(parseFloat(s))
}

export const formatPercentage = (percentage: string): string => {
  if (!percentage) return '-'

  const numValue = parseFloat(percentage)

  if (isNaN(numValue)) return '-'

  if (numValue === 0) {
    return '0.00%'
  }

  let decimalPlaces = 2

  if (Math.abs(numValue) < 0.01) {
    decimalPlaces = 4
  } else if (Math.abs(numValue) < 1) {
    decimalPlaces = 3
  }

  const formattedValue = numValue.toFixed(decimalPlaces)

  const parts = formattedValue.split('.')

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return parts.length > 1 ? `${parts[0]}.${parts[1]}%` : `${parts[0]}%`
}
